import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-time',
  templateUrl: './icon-time.component.html',
  styleUrls: ['./icon-time.component.scss']
})
export class IconTimeComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;
  
  constructor() { }

  ngOnInit() {
  }

}
